module.exports = __webpack_public_path__ + "fonts/TiemposTextWeb-RegularItalic.f9a50b7e.woff";